export default __webpack_public_path__ + "static/media/client-21.356b0bca.png";